import { create } from 'zustand'

export interface BackgroundTask {
  id: string
  jobId: string
  title: string
  status: 'polling' | 'completed' | 'failed'
  progress?: number
  currentItem?: number
  totalItems?: number
  message?: string
  error?: string | null
  redirectUrl?: string
  startupId?: string
  completedActionUrl?: string
  completedTitle?: string
  completedMessage?: string
  queryKeysToInvalidate?: string[][]
  createdAt: number
}

interface BackgroundTaskState {
  tasks: Record<string, BackgroundTask>
  addTask: (task: Omit<BackgroundTask, 'id' | 'createdAt'>) => string
  updateTask: (id: string, updates: Partial<BackgroundTask>) => void
  removeTask: (id: string) => void
}

export const useBackgroundTaskStore = create<BackgroundTaskState>((set) => ({
  tasks: {},

  addTask: (task) => {
    const id = crypto.randomUUID()
    set((state) => ({
      tasks: {
        ...state.tasks,
        [id]: { ...task, id, createdAt: Date.now() },
      },
    }))
    return id
  },

  updateTask: (id, updates) => {
    set((state) => {
      const existing = state.tasks[id]
      if (!existing) return state
      return {
        tasks: {
          ...state.tasks,
          [id]: { ...existing, ...updates },
        },
      }
    })
  },

  removeTask: (id) => {
    set((state) => {
      const { [id]: _, ...rest } = state.tasks
      return { tasks: rest }
    })
  },
}))
